import { ComponentVersions_3_0, ComponentVersionsInherit, Typography } from 'opensolar-ui'

const TransactionTitle = ({ record, translate, style }) => {
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Typography style={style}>
        {translate('Transaction')} {record ? `"${record.id}"` : ''}
      </Typography>
    </ComponentVersionsInherit>
  )
}
export default {
  list: { lazy: () => import('./Transactions'), component: 'TransactionList' },
  edit: { lazy: () => import('./Transactions'), component: 'TransactionEdit' },
  create: { lazy: () => import('./Transactions'), component: 'TransactionCreate' },
  options: {
    create: {
      title: 'Create Transaction',
      subtitle: null,
      breadCrumb: 'Create Transaction',
    },
    list: {
      title: 'Project Transactions',
      subtitle: 'View and add new transactions here for your projects. Track how payments are going for your projects.',
      breadCrumb: 'Transactions',
    },
    edit: {
      title: <TransactionTitle />,
      subtitle: null,
      breadCrumb: 'Edit Transaction',
    },
  },
}
